<template>
  <div class="solveView">
    <!-- 标题图片 -->
    <div class="title" @click="goAbout" >
      <img src="./img/title.png" alt="">
    </div>
    <!-- 内容 -->
    <div class="solveMerge"  v-for="item in solveTitle" :key="item.ID">
      <p class="solveTitle">
        <span>{{item.Name}}</span>
      </p>
      <!-- 解决方案列表组件 -->
      <pc-solve-title :solve-id= item.ID />
    </div>
    <!-- 如果没数据显示 -->
    <div class="noContent" v-show="solveTitle.length===0">
            <img src="~@/assets/img/noContent.png" alt="">
    </div>
  </div>
</template>

<script>
import PcSolveTitle from './components/solveList/PcSolveTitle.vue'
export default {
  components: { PcSolveTitle },
  computed: {
    solveTitle () {
      return this.$store.state.solveTitle
    }
  },
  methods: {
    goAbout () {
      this.$router.push('/aboutUs')
      this.activeIndex = '/aboutUs'
      this.$store.commit('getActiveIndex', '/aboutUs')
      localStorage.setItem('index', '/aboutUs')
    }
  }

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.solveView{
  width: 100%;
  .title{
    width: 100%;
    height: 460px*$sun;
    margin-bottom: 50px*$sun;
    cursor: pointer;
    img{
      width: 100%;
      height: 460px*$sun;
    }
  }
}
.solveMerge{
    margin-bottom: 50px*$sun;
    overflow: hidden;
}
.solveTitle{
  display: flex;
  justify-content: space-between;
  width: 1200px*$sun;
  height: 50px*$sun;
  margin: 0 auto;
  margin-bottom: 30px*$sun;
  border-bottom: 2px*$sun solid #E6E6E6;
  span{
    font-size: 26px*$sun;
    font-weight: 500;
  }
}

// 没信息是显示
.noContent{
  display: flex;
  justify-content: center;
  // margin-top: 20px*$sun;
  margin-bottom: 60px*$sun;
}
</style>
